import React, { useContext } from "react";
import { techStack } from "../constants";
import { ThemeContext } from "../themeProvider";
import { motion } from "framer-motion";
import nikhil from "../assets/nikhil.jpeg";

const About = () => {
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;
  return (
    <div id="about" className={darkMode === true ? "bg-white" : "bg-gray-900"}>
      <div className="max-w-7xl mx-auto x-4 sm:px-6 lg:px-8 px-4 md:mt-0 pt-24 pb-12">
        <div
          className={`text-center mb-12 border rounded-lg p-6 shadow-lg 
        ${!darkMode
              ? "border-purple-500 bg-gradient-to-r from-purple-700 via-purple-800 to-gray-800"
              : "border-blue-500 bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500"
            }`}
        >
          <h3
            className={
              darkMode
                ? "text-4xl font-extrabold text-white"
                : "text-4xl font-extrabold text-white"
            }
          >
            2+ Years Experience | 5+ Projects Completed
          </h3>
        </div>
        <h2
          className={
            darkMode
              ? "text-5xl font-bold px-4 md:px-0 text-center"
              : "text-5xl font-bold px-4 md:px-0 text-center text-white"
          }
        >
          About Me
        </h2>
        <br />
        <div>
          <motion.div>
            <p
              className={
                darkMode
                  ? "mt-4 text-xl text-justify text-gray-500"
                  : "mt-4 text-xl text-justify text-white"
              }
            >
              Passionate about building meaningful tech. Exploring Software
              Engineering, full-stack development, user experiences, and
              responsible AI. I enjoy learning and contributing through coding
              and collaboration.
            </p>
          </motion.div>
          <motion.div className="mt-12 flex flex-col md:flex-row items-center justify-center gap-8">
            <img
              src={nikhil}
              alt="Profile_picture"
              className="w-64 object-contain rounded-lg shadow-lg"
            />
            <div className="text-left">
              <div
                className={`mt-6 space-y-2 text-base ${darkMode ? "text-gray-700" : "text-gray-300"
                  }`}
              >
                <p>
                  <span className="font-semibold">Nationality:</span> Indian
                </p>
                <p>
                  <span className="font-semibold">Location:</span> Oregon, USA
                </p>
                <p>
                  <span className="font-semibold">Demonstrated Expertise:</span>{" "}
                  2+ Years
                </p>
                <p>
                  <span className="font-semibold">Current Role:</span> Graduate
                  Student
                </p>
                <p>
                  <span className="font-semibold">Open to Collaboration:</span>{" "}
                  Yes
                </p>
                <p>
                  <span className="font-semibold">Core Competencies:</span>{" "}
                  Software Engineering, Full-Stack Dev, UI/UX
                </p>
                <p>
                  <span className="font-semibold">Personal Pursuits:</span>{" "}
                  Website Development, Tech Market Trends, Gaming, and AI/ML
                </p>
              </div>
            </div>
          </motion.div>
          <motion.div>
            <h4 className="mt-12 text-3xl font-semibold text-blue-500">
              Technologies and Tools
            </h4>
            <p
              className={
                darkMode
                  ? "mt-4 text-xl text-justify text-gray-500"
                  : "mt-4 text-xl text-justify text-white"
              }
            >
              Using a combination of cutting-edge technologies and reliable
              open-source software I build user-focused, performant websites for
              desktops.
            </p>
          </motion.div>
          <div className="flex flex-col items-center">
            <h3 className="text-2xl font-bold mt-8 text-blue-400">
              Programming Languages
            </h3>
            <div className="flex flex-wrap justify-center items-center mt-4">
              {techStack.programming.map((el, index) => (
                <motion.div
                  key={index}
                  initial="hidden"
                  whileInView="visible"
                  variants={{
                    visible: {
                      y: 0,
                      opacity: 1,
                      transition: {
                        type: "spring",
                      },
                    },
                    hidden: { opacity: 1, y: 80 },
                  }}
                  className="py-2 px-4 bg-gray-50 md:m-4 mx-2 mt-6 rounded-lg flex items-center gap-x-2 hover:scale-125 cursor-pointer md:w-48 w-40"
                >
                  <img alt={el.name} src={el.link} className="w-10" />
                  <h4 className="mt-2 text-center">{el.name}</h4>
                </motion.div>
              ))}
            </div>

            <h3 className="text-2xl font-bold mt-8 text-green-400">
              Frameworks & Libraries
            </h3>
            <div className="flex flex-wrap justify-center items-center mt-4">
              {techStack.frameworks.map((el, index) => (
                <motion.div
                  key={index}
                  initial="hidden"
                  whileInView="visible"
                  variants={{
                    visible: {
                      y: 0,
                      opacity: 1,
                      transition: {
                        type: "spring",
                      },
                    },
                    hidden: { opacity: 1, y: 80 },
                  }}
                  className="py-2 px-4 bg-gray-50 md:m-4 mx-2 mt-6 rounded-lg flex items-center gap-x-2 hover:scale-125 cursor-pointer md:w-48 w-40"
                >
                  <img alt={el.name} src={el.link} className="w-10" />
                  <h4 className="mt-2 text-center">{el.name}</h4>
                </motion.div>
              ))}
            </div>

            <h3 className="text-2xl font-bold mt-8 text-purple-400">
              Cloud & Tools
            </h3>
            <div className="flex flex-wrap justify-center items-center mt-4">
              {techStack.cloud.map((el, index) => (
                <motion.div
                  key={index}
                  initial="hidden"
                  whileInView="visible"
                  variants={{
                    visible: {
                      y: 0,
                      opacity: 1,
                      transition: {
                        type: "spring",
                      },
                    },
                    hidden: { opacity: 1, y: 80 },
                  }}
                  className="py-2 px-4 bg-gray-50 md:m-4 mx-2 mt-6 rounded-lg flex items-center gap-x-2 hover:scale-125 cursor-pointer md:w-48 w-40"
                >
                  <img alt={el.name} src={el.link} className="w-10" />
                  <h4 className="mt-2 text-center">{el.name}</h4>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
